// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__fzLK-","fadeIn":"ScrollToTop_fadeIn__U7XZ1","iconContainer":"ScrollToTop_iconContainer__xAE7K","icon":"ScrollToTop_icon__ECRbf"};